import BaseModel from "lib/model";
import Actions from "collections/actions";

export default BaseModel.extend({
    collections: {
        __actions: Actions,
    },
});
